import type { PropsWithChildren, ReactNode } from "react";
import { Card, CardContent, CardHeader } from "@mui/material";
import { Link } from "react-router-dom";

type WidgetCardProps = {
	title: ReactNode;
	action?: ReactNode;
	url?: string;
};

const WidgetCard = ({ title, action, url, children }: PropsWithChildren<WidgetCardProps>) => {
	const card = (
		<Card sx={{ boxShadow: 1, display: "flex", flexDirection: "column", height: "100%" }}>
			<CardHeader
				title={title}
				action={action}
				slotProps={{
					title: {
						fontSize: 14,
						fontWeight: 600,
						letterSpacing: 1,
					},
				}} />

			<CardContent sx={{
				display: "flex",
				flex: 1,
				flexDirection: "column",
				minHeight: 0,
			}}>
				{children}
			</CardContent>
		</Card>
	);

	if (!url) {
		return card;
	}

	return <Link to={url} style={{ color: "inherit", display: "block", height: "100%", textDecoration: "none" }}>
		{card}
	</Link>;
};

export default WidgetCard;
